import { html } from 'lit';
import parse from 'html-react-parser';
import { formatDateObject } from './dateUtils';

export const getValue = (event) => {
  let value = '';
  if (Array.isArray(event.target.value) && typeof event.target.value[0] === 'string') {
    value = event.target.value[0];
  } else if (Array.isArray(event.target.value) && typeof event.target.value[0] === 'object') {
    value = event.target.value[0].id;
  } else {
    value = event.target.value;
  }
  return value;
};

export const onDateChange = (event, value) => {
  event.target.value = value;
};

export const createDateInput = (dateInputValues, changeFn, value = null) => {
  return html`<input
    class="input is-static is-editable"
    part="date-input"
    ?disabled=${dateInputValues.disabled}
    data-date=${dateInputValues.value ? formatDateObject(dateInputValues.value) : "Mon DD, YYYY"}
    id=placement-flight-start-date-${dateInputValues.index}
    type='date'
    .value=${dateInputValues.value}
    min=${dateInputValues.min}
    max=${dateInputValues.max}
    activeStartDate=${dateInputValues.value}
    @change=${(event) => changeFn(dateInputValues.inputLabel, event, value, dateInputValues.index)}
    @click=${(event) => onDateChange(event, dateInputValues.value)}
    @blur=${(event) => onDateChange(event, dateInputValues.value)}
  >`;
};

export const assignInlineStyleOnRuntime = (elementHTML, styles) => {
  let stylesKeys = Object.keys(styles);
  for (let i = 0; i < stylesKeys.length; i++) {
    elementHTML.style[stylesKeys[i]] = styles[stylesKeys[i]];
  }
};

export const waitForElm = (parentNode, elmToWait) => {
  return new Promise(resolve => {
    if (elmToWait) {
      return resolve(elmToWait);
    }
    const observer = new MutationObserver(mutations => {
      if (elmToWait) {
        observer.disconnect();
        resolve(elmToWait);
      }
    });
    observer.observe(parentNode, {
      childList: true,
      subtree: true
    });
  });
};

export const displayTableSkeleton = () => {
  let rows = '';
  for (let i = 0; i < 10; i++) {
    rows = rows + '<div className="table skeleton"></div>';
  }
  rows = (html`${rows}`);
  return <>{parse(rows.values[0])}</>;
};

export const showDownloadModal = (exportResponse) => {
  let omniDialogEl = document.getElementById('export-placement-dialog');
  let downloadBtn = document.getElementById('export-placement-download-btn');
  downloadBtn.href = exportResponse.s3PresignedUrl;
  omniDialogEl.showModal();
  omniDialogEl.shadowRoot.querySelector('dialog').style.width = '600px';
};

export const exportToExcel = async (exportData, sheetName, fileName) => {
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, fileName);
};

export const calculatetaxonomyWidth = (taxonomy, isPlacementTable) => {
  let spanEl = document.createElement("SPAN");
  let taxnomyText = document.createTextNode(taxonomy);
  spanEl.appendChild(taxnomyText);
  document.body.appendChild(spanEl);
  spanEl.style.whiteSpace = 'nowrap';
  let taxonomyWidth = spanEl.offsetWidth;
  document.body.removeChild(spanEl);
  if (taxonomyWidth < 500 && isPlacementTable) return '500px';
  else if (taxonomyWidth < 500 && !isPlacementTable) return taxonomyWidth + 50 + 'px';
  else {
    if ((taxonomyWidth / 2 + 50) < 500) return '500px';
    else return taxonomyWidth / 2 + 50 + 'px';
  }
};

export const splitByDelimiters = (str, delimiters) => {
  const regex = new RegExp(`([${delimiters.join('')}])`);
  return str?.split(regex).filter(Boolean);
};

export const highlightDifferences = (stringsObj, delimiters, taxonomyFields) => {
  const taxonomyfieldSourceString = taxonomyFields.map(field => field?.source || 'null').join('_');
  const taxonomySourceParts = splitByDelimiters(taxonomyfieldSourceString, ['_']);
  const keys = Object.keys(stringsObj);
  let strings = keys.map(key => stringsObj[key]);
  const maxLength = Math.max(...strings.map(str => splitByDelimiters(str, delimiters)?.length));
  const results = {};

  keys.forEach(key => {
    results[key] = [];
  });

  for (let i = 0; i < maxLength; i++) {
    const parts = strings.map(str => splitByDelimiters(str, delimiters)[i] || '');
    const allEqual = parts.every(part => part === parts[0]);

    keys.forEach((key, j) => {
      if (delimiters.includes(parts[j])) {
        results[key].push(html`<span>${parts[j]}</span>`);
      } else if (allEqual) {
        results[key].push(html`<span>${parts[j]}</span>`);
      } else if (taxonomySourceParts[i]?.toLowerCase() === 'planit') {
        results[key].push(html`<span part="highlight-difference">${parts[j]}</span>`);
      } else {
        results[key].push(html`<span>${parts[j]}</span>`);
      }
    });
  }

  return results;
};
